import React, { useState, useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Highcharts3D from "highcharts/highcharts-3d";
import html2canvas from "html2canvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaBars } from "react-icons/fa";
import Cards from "../components/CardThree";

Highcharts3D(Highcharts);

const dataSets = {
  BUCAs: {
    "Record Count": [
      { name: "AETNA", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      { name: "BCBS", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      { name: "Cigna", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      { name: "UHC", data: [null, 99.73, 0.13, 0.15, null, null] },
    ],

    "Billing Code Count": [
      { name: "AETNA", data: [91.34, 86.89, 5.91, 73.43, null, null] },
      { name: "BCBS", data: [76.38, 73.54, 52.58, 76.38, 43.58, 36.75] },
      { name: "Cigna", data: [79.88, 79.88, 3.23, 59.26, 11.16, null] },
      { name: "UHC", data: [null, 98.89, 2.4, 32.22, null, null] },
    ],

    "Provider Count": [
      { name: "AETNA", data: [61.42, 41.89, 2.06, 3.37, null, null] },
      { name: "BCBS", data: [65.0, 44.58, 3.91, 11.84, 2.72, 0.6] },
      { name: "Cigna", data: [96.51, 6.65, 0.25, 14.12, 0.0, null] },
      { name: "UHC", data: [null, 98.57, 2.4, 1.05, null, null] },
    ],
    "TIN Count": [
      { name: "AETNA", data: [74.74, 26.86, 4.21, 3.37, null, null] },
      { name: "BCBS", data: [62.39, 42.68, 6.24, 11.22, 2.6, 1.23] },
      { name: "Cigna", data: [97.24, 5.05, 0.26, 12.55, null, null] },
      { name: "UHC", data: [null, 97.14, 5.08, 1.05, null, null] },
    ],
  },
  "Non-BUCAs": {
    "Record Count": [
      { name: "MMO", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      { name: "Centene", data: [8.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      { name: "FirstChoice", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      { name: "SelectHealth", data: [null, 99.73, 0.13, 0.15, null, null] },
      { name: "Medcost", data: [8.74, 37.05, 0.19, 4.01, null, null] },
      { name: "GEHA", data: [28.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      { name: "Trustmark", data: [34.07, 15.1, 0.01, 0.8, 0.01, null] },
      { name: "FirstHealth", data: [null, 99.73, 0.13, 0.15, null, null] },
      { name: "Kaiser", data: [98.74, 37.05, 0.19, 4.01, null, null] },
      { name: "AvMed", data: [28.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "Medica", data: [14.07, 15.1, 0.01, 0.8, 0.01, null] },
      // { name: "ProviDrs", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "Claritev", data: [78.74, 37.05, 0.19, 4.01, null, null] },
      // { name: "HealthLink", data: [98.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "MidlandsChoice", data: [4.07, 15.1, 0.01, 0.8, 0.01, null] },
      // { name: "AmericasPPO", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "UPMC", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "Oscar", data: [74, 37.05, 0.19, 4.01, null, null] },
      // { name: "PriorityHealth", data: [52, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "HealthPartners", data: [1, 15.1, 0.01, 0.8, 0.01, null] },
      // { name: "Wellmark", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "EmblemHealth", data: [0.1, 37.05, 0.19, 4.01, null, null] },
      // { name: "AultCare", data: [0.7, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "MVPHealthPlan", data: [7, 15.1, 0.01, 0.8, 0.01, null] },
      // {
      //   name: "HealthAllianceMichigan",
      //   data: [null, 99.73, 0.13, 0.15, null, null],
      // },
    ],

    "Billing Code Count": [
      { name: "AETNA", data: [91.34, 86.89, 5.91, 73.43, null, null] },
      { name: "BCBS", data: [76.38, 73.54, 52.58, 76.38, 43.58, 36.75] },
      { name: "Cigna", data: [79.88, 79.88, 3.23, 59.26, 11.16, null] },
      { name: "UHC", data: [null, 98.89, 2.4, 32.22, null, null] },
    ],

    "Provider Count": [
      { name: "AETNA", data: [61.42, 41.89, 2.06, 3.37, null, null] },
      { name: "BCBS", data: [65.0, 44.58, 3.91, 11.84, 2.72, 0.6] },
      { name: "Cigna", data: [96.51, 6.65, 0.25, 14.12, 0.0, null] },
      { name: "UHC", data: [null, 98.57, 2.4, 1.05, null, null] },
    ],
    "TIN Count": [
      { name: "AETNA", data: [74.74, 26.86, 4.21, 3.37, null, null] },
      { name: "BCBS", data: [62.39, 42.68, 6.24, 11.22, 2.6, 1.23] },
      { name: "Cigna", data: [97.24, 5.05, 0.26, 12.55, null, null] },
      { name: "UHC", data: [null, 97.14, 5.08, 1.05, null, null] },
    ],
  },
  All: {
    "Record Count": [
      { name: "AETNA", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      { name: "BCBS", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      { name: "Cigna", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      { name: "UHC", data: [null, 99.73, 0.13, 0.15, null, null] },
      { name: "MMO", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      { name: "Centene", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      { name: "FirstChoice", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      { name: "SelectHealth", data: [null, 99.73, 0.13, 0.15, null, null] },
      { name: "Medcost", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      { name: "GEHA", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      { name: "Trustmark", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      // { name: "FirstHealth", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "Kaiser", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      // { name: "AvMed", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "Medica", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      // { name: "ProviDrs", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "Claritev", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      // { name: "HealthLink", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "MidlandsChoice", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      // { name: "AmericasPPO", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "UPMC", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "Oscar", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      // { name: "PriorityHealth", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "HealthPartners", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      // { name: "Wellmark", data: [null, 99.73, 0.13, 0.15, null, null] },
      // { name: "EmblemHealth", data: [58.74, 37.05, 0.19, 4.01, null, null] },
      // { name: "AultCare", data: [58.77, 36.78, 0.85, 2.5, 0.69, 0.4] },
      // { name: "MVPHealthPlan", data: [84.07, 15.1, 0.01, 0.8, 0.01, null] },
      {
        name: "HealthAllianceMichigan",
        data: [null, 99.73, 0.13, 0.15, null, null],
      },
    ],

    "Billing Code Count": [
      { name: "AETNA", data: [91.34, 86.89, 5.91, 73.43, null, null] },
      { name: "BCBS", data: [76.38, 73.54, 52.58, 76.38, 43.58, 36.75] },
      { name: "Cigna", data: [79.88, 79.88, 3.23, 59.26, 11.16, null] },
      { name: "UHC", data: [null, 98.89, 2.4, 32.22, null, null] },
    ],

    "Provider Count": [
      { name: "AETNA", data: [61.42, 41.89, 2.06, 3.37, null, null] },
      { name: "BCBS", data: [65.0, 44.58, 3.91, 11.84, 2.72, 0.6] },
      { name: "Cigna", data: [96.51, 6.65, 0.25, 14.12, 0.0, null] },
      { name: "UHC", data: [null, 98.57, 2.4, 1.05, null, null] },
    ],
    "TIN Count": [
      { name: "AETNA", data: [74.74, 26.86, 4.21, 3.37, null, null] },
      { name: "BCBS", data: [62.39, 42.68, 6.24, 11.22, 2.6, 1.23] },
      { name: "Cigna", data: [97.24, 5.05, 0.26, 12.55, null, null] },
      { name: "UHC", data: [null, 97.14, 5.08, 1.05, null, null] },
    ],
  },
};
const categories = [
  "Fee Schedule",
  "Negotiated",
  "Percentage",
  "Per Diem",
  "Derived",
  "Bundle",
];

const stateList = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

const handleStateChange = (state) => {
  console.log("Selected state:", state);
  // You can add logic here to update chart or other data
};

const customColors = [
  "#FFB997",
  "#C1E7E7",
  "#FFD3B4",
  "#A8E8FF",
  "#ccdaf5",
  "#c0bbc9",
  "#a9dbef ",
  "#ceedd0",
  "#BEAFE8",
  "#8ACCD5",
  "#D3D89F",
  "#85C2C9",
];

const Percentange2D = () => {
  const [selectedState, setSelectedState] = useState("California");
  const [selectedCarrier, setSelectedCarrier] = useState("Non-BUCA’s");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("BUCAs");
  const [selectedMetric, setSelectedMetric] = useState("Record Count");
  const [metricDropdownOpen, setMetricDropdownOpen] = useState(false);
  const [seriesData, setSeriesData] = useState([]);
  const [isAutoScale, setIsAutoScale] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const chartContainerRef = useRef(null);

  useEffect(() => {
    const currentData = dataSets[selectedGroup]?.[selectedMetric];
    setSeriesData(currentData || []);
  }, [selectedGroup, selectedMetric]);

  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", onFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", onFullScreenChange);
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => {
      if (!prev) setMetricDropdownOpen(false); // Close metric dropdown when opening main dropdown
      return !prev;
    });
  };

  const toggleMetricDropdown = () => {
    setMetricDropdownOpen((prev) => {
      if (!prev) setDropdownOpen(false); // Close main dropdown when opening metric dropdown
      return !prev;
    });
  };

  const calculateYAxisMax = (index) => {
    if (!isAutoScale) return 100;
    const values = seriesData
      .map((s) => s.data[index])
      .filter((v) => v != null);
    const maxValue = values.length ? Math.max(...values) : 0;
    return maxValue < 10 ? 10 : 100;
  };

  const handleFullScreen = () => {
    const el = chartContainerRef.current;
    if (document.fullscreenElement) document.exitFullscreen();
    else el?.requestFullscreen();
  };

  const captureScreenshot = async () => {
    if (!chartContainerRef.current) return;
    const canvas = await html2canvas(chartContainerRef.current, {
      useCORS: true,
      scale: 2,
    });
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = "chart.png";
    link.click();
  };

  const renderChart = (category, index) => {
    const data = seriesData.map((s, i) => ({
      name: s.name,
      data: [s.data[index]],
      color: customColors[i],
    }));
    const yAxisMax = calculateYAxisMax(index);

    return (
      <div key={category} className="col-md-6 col-lg-4 mb-4 ">
        <div
          className="card  h-100"
          style={{ border: "none", boxShadow: "none" }}
        >
          <div className="card-body">
            <h6 className="card-title text-center mb-3">{category}</h6>
            <HighchartsReact
              highcharts={Highcharts}
              options={{
                chart: {
                  type: "column",
                  height: 250,
                  padding: 0,
                },

                title: { text: null },
                xAxis: { categories: [category] },
                yAxis: {
                  min: 0,
                  max: yAxisMax,
                  title: null,
                  labels: {
                    formatter() {
                      return `${this.value}%`;
                    },
                  },
                },
                tooltip: {
                  useHTML: true,
                  headerFormat: `<strong>{point.key}</strong><br/>`,
                  pointFormat: `<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}%</b><br/>`,
                },
                legend: { enabled: false },
                exporting: { enabled: false },
                plotOptions: {
                  column: { borderRadius: 5 },
                  series: {
                    dataLabels: { enabled: false, format: "{y}%" },
                  },
                },
                series: data,
                credits: { enabled: false },
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      // className="bg-white  pt-4 "
      style={{
        border: "none",
        borderRadius: "8px",
        margin: "0px 20px",
        // padding: "0px 10px",
      }}
    >
      <div className="container d-flex flex-column " ref={chartContainerRef}>
        <Cards />
        {/* Controls */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
          <div className="d-flex gap-3 mb-2">
            <div className="dropdown ">
              <button
                className="btn btn-outline-secondary dropdown-toggle"
                variant="primary"
                id="dropdown-basic"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: "180px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {selectedMetric || "Select Metric"}
              </button>
              <ul className="dropdown-menu">
                {Object.keys(dataSets[selectedGroup] || {}).map((metric) => (
                  <li key={metric}>
                    <button
                      className={`dropdown-item ${
                        selectedMetric === metric ? "active" : ""
                      }`}
                      onClick={() => setSelectedMetric(metric)}
                    >
                      {metric}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="dropdown">
              <a
                className="btn btn-secondary dropdown-toggle p-2"
                href="#"
                variant="primary"
                id="dropdown-basic"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: "180px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {selectedState || "Select State"}
              </a>

              <ul
                className="dropdown-menu"
                style={{ maxHeight: "140px", overflowY: "auto" }}
              >
                {stateList.map((state) => (
                  <li key={state}>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedState(state);
                        handleStateChange(state);
                      }}
                    >
                      {state}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="dropdown">
              <button
                className="btn btn-outline-primary dropdown-toggle"
                variant="primary"
                id="dropdown-basic"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  width: "180px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {selectedGroup || "Select Group"}
              </button>
              <ul className="dropdown-menu">
                {Object.keys(dataSets).map((group) => (
                  <li key={group}>
                    <button
                      className={`dropdown-item ${
                        selectedGroup === group ? "active" : ""
                      }`}
                      onClick={() => setSelectedGroup(group)}
                    >
                      {group}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* 
        <div className="btn-group">
          <button className="btn btn-outline-dark" onClick={handleFullScreen}>
            <FaExpand className="me-1" />
            {isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
          </button>
          <button className="btn btn-outline-dark" onClick={captureScreenshot}>
            <FaDownload className="me-1" />
            Download
          </button>
        </div> */}
          <div className="position-relative">
            {/* Menu button */}
            <button
              className="btn border p-2"
              onClick={toggleDropdown}
              style={{ backgroundColor: "white" }}
            >
              <FaBars size={20} />
            </button>

            {/* Dropdown Menu */}
            {dropdownOpen && (
              <div
                className="position-absolute bg-white border rounded shadow p-2"
                style={{
                  right: 0,
                  top: "110%",
                  minWidth: "180px",
                  zIndex: 10,
                }}
              >
                <button
                  className="dropdown-item p-2"
                  onClick={captureScreenshot}
                >
                  Download
                </button>
                <button
                  className="dropdown-item p-2"
                  onClick={handleFullScreen}
                >
                  {isFullScreen ? "Exit Full Screen" : "View Full Screen"}
                </button>
                <button
                  className="dropdown-item p-2"
                  onClick={() => setIsAutoScale(!isAutoScale)}
                >
                  {isAutoScale
                    ? "Switch to Manual Scaling"
                    : "Switch to Auto Scaling"}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Charts */}
        <div
          className="row bg-white"
          style={{
            borderRadius: "10px",
            padding: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="col-12 d-flex justify-content-center mb-3">
            <h4>
              <b>Selected Metrics by Negotiation Arrangement</b>
            </h4>
          </div>
          <div
            className="d-flex justify-content-center mt-3 "
            style={{
              width: "80%",
              overflow: "scroll",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "30px",
            }}
          >
            {seriesData.map((s, i) => (
              <div key={s.name} className="d-flex align-items-center mx-3">
                <div
                  style={{
                    width: 16,
                    height: 16,
                    backgroundColor: customColors[i],
                    borderRadius: "50%",
                    marginRight: 8,
                  }}
                />
                <span>{s.name}</span>
              </div>
            ))}
          </div>

          {categories.map((category, index) => renderChart(category, index))}
        </div>
        {/* Legend */}
      </div>
    </div>
  );
};

export default Percentange2D;
